(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicCategoryDialogController', CommunicationTopicCategoryDialogController);

    CommunicationTopicCategoryDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationTopicCategory'];

    function CommunicationTopicCategoryDialogController ($scope, $stateParams, $uibModalInstance, entity, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopicCategory = entity;
        vm.load = function(id) {
            CommunicationTopicCategory.get({id : id}, function(result) {
                vm.communicationTopicCategory = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:communicationTopicCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationTopicCategory.id !== null) {
                CommunicationTopicCategory.update(vm.communicationTopicCategory, onSaveSuccess, onSaveError);
            } else {
                CommunicationTopicCategory.save(vm.communicationTopicCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
